import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "./component";
import ShareReport from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ShareReport);
